import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import VyTooltip from '../../../../../../../common/VyTooltip';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, IconButton } from '@mui/material';
import { useSelector } from '../../../../../../../../reduxToolkit/typedRedux';
import { presentationSlotTypes } from '../../../../../../../../interfaces/interfaces';
import { MdChevronLeft } from 'react-icons/md';
import { SupportedFunctions, useEventFunctions } from '../../../../../../../../hooks/useEventFunctions';

interface PresentationType {
  name: string;
  value: 'online' | 'hybrid' | 'on-site';
  tooltip: string;
  disabled?: boolean;
}

export const TypeSelect = () => {
  const event = useSelector((state) => state.common.event);

  const { t } = useTranslation();
  const { control, watch } = useFormContext();
  const { isFunctionEnabled } = useEventFunctions();

  const watchValue: presentationSlotTypes = watch('presentationSlotType');

  const meetingDisabled = !isFunctionEnabled(SupportedFunctions.livestreams, event) && !isFunctionEnabled(SupportedFunctions.videomeet, event);
  const types: PresentationType[] = [
    {
      name: t('account:presentation-types.online'),
      value: 'online',
      tooltip: t('account:presentation-types.online-tooltip'),
      disabled: meetingDisabled,
    },
    {
      name: t('account:presentation-types.hybrid'),
      value: 'hybrid',
      tooltip: t('account:presentation-types.hybrid-tooltip'),
      disabled: meetingDisabled,
    },
    {
      name: t('account:presentation-types.on-site'),
      value: 'on-site',
      tooltip: t('account:presentation-types.on-site-tooltip'),
    },
  ];

  return (
    <Controller
      control={control}
      rules={{ required: true }}
      name="presentationSlotType"
      render={({ field: { onChange } }) => (
        <FormControl>
          <div className="flex items-center space-x-2">
            {watchValue && (
              <VyTooltip title={t('account:overview')}>
                <IconButton className="h-full" onClick={() => onChange(undefined)}>
                  <MdChevronLeft />
                </IconButton>
              </VyTooltip>
            )}
            <div className={`w-full flex justify-between flex-col space-y-4`}>
              {types
                .filter((type) => !watchValue || watchValue === type.value)
                .map((type) => (
                  <VyTooltip title={watchValue ? type.tooltip : type.disabled ? t('account:presentationtype-disabled-because-eventfunctions-disabled') : ''}>
                    <div
                      className={`flex justify-center items-center flex-col p-4 text-justify space-y-2 border-2 rounded ${
                        type.disabled ? '' : 'border-vystemblue'
                      } ${watchValue ? '' : type.disabled ? 'bg-slate-100' : 'cursor-pointer hover:bg-blue-50'}`}
                      onClick={() => {
                        if (!type.disabled) onChange(type.value);
                      }}>
                      <p className="text-lg font-bold text-slate-700"> {type.name}</p>
                      {!watchValue && <p className="text-slate-700">{type.tooltip}</p>}
                    </div>
                  </VyTooltip>
                ))}
            </div>
          </div>
        </FormControl>
      )}
    />
  );
};
